import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useModalStore = defineStore('modal', () => {
  const isLoginModalOpen = ref(false)
  const isContactModalOpen = ref(false)

  const openLoginModal = () => {
    isLoginModalOpen.value = true
  }

  const closeLoginModal = () => {
    isLoginModalOpen.value = false
  }

  const openContactModal = () => {
    isContactModalOpen.value = true
  }

  const closeContactModal = () => {
    isContactModalOpen.value = false
  }

  return {
    isLoginModalOpen,
    openLoginModal,
    closeLoginModal,
    isContactModalOpen,
    openContactModal,
    closeContactModal
  }
})
